import { render } from "./RequirementsStep.vue?vue&type=template&id=465728f9&scoped=true"
import script from "./RequirementsStep.vue?vue&type=script&lang=js"
export * from "./RequirementsStep.vue?vue&type=script&lang=js"

import "./RequirementsStep.vue?vue&type=style&index=0&id=465728f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465728f9"]])

export default __exports__